import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('BillToUpsInput')
export class BillToUps {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('bups'), index: true })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  account: string

  @Field(() => String)
  @Prop({ type: String })
  countryCode: string

  @Field(() => String)
  @Prop({ type: String })
  postalCode: string
}
